import React from 'react';
import { Link } from 'react-router-dom';
import { useI18n } from '../../context/I18nContext';
import { useConsent } from '../../context/ConsentContext';
import Button from '../ui/Button';
import { clickableLinks } from '../../styles/colors';
import { PRIVACY_COOKIES_PATH } from '../../utils/legalLinks';

const CookieBanner: React.FC = () => {
  const { t } = useI18n();
  const { showBanner, acceptAll, rejectAll, openPreferences } = useConsent();

  if (!showBanner) return null;

  return (
    <div
      role="dialog"
      aria-labelledby="cookie-banner-title"
      aria-describedby="cookie-banner-description"
      className="fixed inset-x-0 bottom-0 z-40 rounded-t-2xl border-t border-gray-200 bg-white/95 backdrop-blur-md shadow-[0_-8px_32px_rgba(15,23,42,0.12)]"
    >
      <div className="mx-auto flex max-w-7xl flex-col gap-2 px-4 py-3 sm:gap-3 sm:px-6 sm:py-4 lg:flex-row lg:items-center lg:justify-between">
        <div className="min-w-0 flex-1">
          <p id="cookie-banner-title" className="text-sm font-semibold text-gray-900">
            {t('cookies.bannerTitle')}
          </p>
          <p
            id="cookie-banner-description"
            className="mt-0.5 text-xs leading-snug text-gray-600 sm:mt-1 sm:text-sm"
          >
            {t('cookies.bannerDescription')}
          </p>
          <p className="mt-1 text-xs sm:text-sm">
            {t('cookies.learnMoreIn')}{' '}
            <Link to={PRIVACY_COOKIES_PATH} className={`${clickableLinks} underline`}>
              {t('cookies.privacyLink')}
            </Link>
            .
          </p>
        </div>

        <div className="flex w-full gap-1.5 sm:w-auto sm:gap-2 sm:flex-wrap sm:justify-end">
          <Button
            type="button"
            variant="outline"
            size="sm"
            onClick={rejectAll}
            className="min-h-0 flex-1 px-2 text-xs sm:flex-none sm:px-4 sm:text-sm"
          >
            {t('cookies.rejectAll')}
          </Button>
          <Button
            type="button"
            variant="secondary"
            size="sm"
            onClick={openPreferences}
            className="min-h-0 flex-1 px-2 text-xs sm:flex-none sm:px-4 sm:text-sm"
          >
            {t('cookies.preferences')}
          </Button>
          <Button
            type="button"
            variant="primary"
            size="sm"
            onClick={acceptAll}
            className="min-h-0 flex-1 px-2 text-xs sm:flex-none sm:px-4 sm:text-sm"
          >
            {t('cookies.acceptAll')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
